import { createContext, useContext } from "react";
import { useLocation } from "react-router-dom";

type HomeTeamContextType = {
  name: string;
  code: string;
  highlightColor?: string;
  slogans: { prematch: string; inmatch: string };
};

const HomeTeamContext = createContext<HomeTeamContextType | null>(null);

export function HomeTeamProvider({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  const teams: Record<string, HomeTeamContextType> = {
    "/hns": {
      name: "HNS 🍦",
      code: "HNS",
      slogans: {
        prematch: "Nudging time?",
        inmatch: "Lick 'em!",
      },
    },
    "/dad": {
      name: "D.A.D.",
      code: "DAD",
      slogans: {
        prematch: "Father Time?",
        inmatch: "Deviant Hour 😈",
      },
    },
    "/dse": {
      name: "Dog Soccer",
      code: "DSE",
      slogans: {
        prematch: "Arf arf?",
        inmatch: "Arf arf!",
      },
    },
    "/csp": {
      name: "CSPFC",
      code: "CSP",
      slogans: {
        prematch: "Championship time?",
        inmatch: "Championship time!",
      },
    },
  };

  const homeTeam = teams[location.pathname] ?? {
    name: "OGR4U",
    code: "OGR",
    highlightColor: "primary",
    slogans: {
      prematch: "Cheeseburger Time?",
      inmatch: "It's Cheeseburger Time!",
    },
  };

  return (
    <HomeTeamContext.Provider value={homeTeam}>
      {children}
    </HomeTeamContext.Provider>
  );
}

export function useHomeTeam() {
  const context = useContext(HomeTeamContext);
  if (!context) {
    throw new Error("useHomeTeam must be used within a HomeTeamProvider");
  }
  return context;
}
